module.exports = __webpack_public_path__ + "static/propagation-mobile-510273154d0ee9f846708c69f9f89292.svg";